import UpdateSnAdtInfoDialog from "./updateSnAdtInfoDialog.container";

export default UpdateSnAdtInfoDialog;
